import { logUserDataResponseError, processItemMutateResponse } from './processResponse';
import { makePostRequest, makePutRequest } from 'owa-ows-gateway';
import {
    CreateAndRemoveUserDataItemRequest,
    CreateUserDataItemRequest,
    RequestType,
    UserDataItem,
    UserDataItemResponse,
    UserDataResponseStatus,
} from '../data/schema/UserDataStoreSchema';

const CREATE_USER_DATA_ITEM_NAME = 'CreateUserDataItem';
const CFEATE_AND_REMOVE_USER_DATA_ITEM_NAME = 'CreatAndUpdateUserDataItem';
const USER_DATA_STORE_CREATE_INFO_BASE: string = 'ows/v1.5/UserDataStore/item';
const USER_DATA_STORE_CREATE_AND_REMOVE_INFO_BASE: string = 'ows/v1.5/UserDataStore/items';

/**
 * Create and insert the UserDataItem for the current user with the provided data.
 * The function will return the UserDataItemResponse.
 */
export async function createUserDataInfoService(
    userDataItem: UserDataItem,
    requestType: RequestType
): Promise<UserDataItemResponse> {
    const request: CreateUserDataItemRequest = {
        category: userDataItem.categoryName,
        key: userDataItem.key,
        value: userDataItem.value,
        dataSource: userDataItem.dataSource,
        isPinned: userDataItem.property.isPinned,
        requestType: requestType,
    };
    try {
        const response = await makePostRequest(
            USER_DATA_STORE_CREATE_INFO_BASE,
            request,
            undefined /* correlationId */,
            true /* returnFullResponse */,
            undefined /* customHeaders */,
            undefined /* throwServiceError */,
            undefined /* sendPayloadAsBody */,
            undefined /* includeCredentials */,
            'createUserDataInfo' /* actionName */
        );
        return processItemMutateResponse(response, CREATE_USER_DATA_ITEM_NAME);
    } catch (error) {
        logUserDataResponseError(CREATE_USER_DATA_ITEM_NAME, error?.message);
        return Promise.resolve(<UserDataItemResponse>{
            status: UserDataResponseStatus.UNEXPECTED_ERROR,
        });
    }
}

/**
 * Create and remove service for the current user. The operation will operate the create
 * and remove as a bulk operation and the whole call should fail if any of it failed.
 */
export async function createAndRemoveUserDataInfoService(
    userDataItem: UserDataItem,
    removeItemId: string,
    requestType: RequestType
): Promise<UserDataItemResponse> {
    const request: CreateAndRemoveUserDataItemRequest = {
        addItem: <CreateUserDataItemRequest>{
            category: userDataItem.categoryName,
            key: userDataItem.key,
            value: userDataItem.value,
            dataSource: userDataItem.dataSource,
            isPinned: userDataItem.property.isPinned,
            requestType: requestType,
        },
        removeItemID: removeItemId,
    };
    try {
        const response = await makePutRequest(
            USER_DATA_STORE_CREATE_AND_REMOVE_INFO_BASE,
            request,
            undefined /* correlationId */,
            true /* returnFullResponse */
        );
        return processItemMutateResponse(response, CFEATE_AND_REMOVE_USER_DATA_ITEM_NAME);
    } catch (error) {
        logUserDataResponseError(CFEATE_AND_REMOVE_USER_DATA_ITEM_NAME, error?.message);
        return Promise.resolve(<UserDataItemResponse>{
            status: UserDataResponseStatus.UNEXPECTED_ERROR,
        });
    }
}
